export default __webpack_public_path__ + "static/media/space_object_03.1a805dd8.svg";